export class Errors {
  error: string;
  message: string;
  passwordattempt: number;
  userGroupid: number;
}

